import { DepartmentGetAllUseCase } from '../../../../application';

export default class DepartmentGetAllService {

    async execute(event) {
        const data = await DepartmentGetAllUseCase(event);
        return data;
    }
}
